import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Parametri } from 'src/app/models/parametri';
import { environment } from 'src/environments/environment';
import { ParametriPasswords } from '../utils/ildato-gestione-password/parametri-passwords';

@Injectable({
  providedIn: 'root',
})
export class ParametriService {
  private http = inject(HttpClient);

  parametriUrl = environment.ildatoArticoliDpi + 'api/parametri';

  list(): Observable<Parametri[]> {
    return this.http.get<Parametri[]>(`${this.parametriUrl}`);
  }

  get(parametro: string): Observable<Parametri> {
    return this.http.get<Parametri>(this.parametriUrl + '/' + parametro);
  }

  getParametriPasswords(): Observable<ParametriPasswords> {
    return this.http.get<ParametriPasswords>(
      this.parametriUrl + '/parametripasswords',
    );
  }

  listVisibili(): Observable<Parametri[]> {
    return this.http.get<Parametri[]>(
      this.parametriUrl + '/listparametrivisibili',
    );
  }

  insert(parametro: Parametri): Observable<Parametri> {
    return this.http.post<Parametri>(this.parametriUrl + '/insert', parametro);
  }

  remove(nomeParametro: string): Observable<Parametri> {
    const encodedNome = encodeURIComponent(nomeParametro);
    
    return this.http.delete<Parametri>(
      this.parametriUrl + '/delete/' + encodedNome,
    );
  }

  update(nomeParametro: string, parametro: Parametri): Observable<Parametri> {
    const encodedNome = encodeURIComponent(nomeParametro);

    return this.http.put<Parametri>(
      this.parametriUrl + '/update/' + encodedNome,
      parametro,
    );
  }
}
